// @ts-ignore
import { getBusinessSettings, configBusinessSettings } from '@wix/business-settings-api';

export type BusinessSettings = {
  language: string;
};

export interface BusinessSettingsService {
  configBusinessSettings(options: any): void;
  getBusinessSettings(msid: string): Promise<BusinessSettings>;
}

export const businessSettingsService: BusinessSettingsService = {
  getBusinessSettings,
  configBusinessSettings,
};
